import { Subject ,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProcessDetail } from '../models/process-models';
import { distinctUntilChanged } from 'rxjs/operators';
import { RespondentRedirect } from '../models/RespondentRedirect.Model';

@Injectable()
export class ProcessDetailService {
    clearSelectionClicked$: Observable<any>;
    saveClicked$: Observable<any>;

    private apiController = 'api/process';
    private clearSelectionSubject = new Subject();

    constructor(private http: HttpClient) {
      this.clearSelectionClicked$ = this.clearSelectionSubject.asObservable();
    }

    getProcessDetail(durationId: number): Observable<ProcessDetail> {
      return this.http.get(`${this.apiController}/active/${durationId}`) as Observable<ProcessDetail>;
    }

    getProcessGeneratedLink(processId: number): Observable<RespondentRedirect>{
      return this.http.get(`${this.apiController}/ChooseDestinationPage?processId=${processId}`) as Observable<RespondentRedirect>;
    }

    cancelProcess(processId: number, durationId: number): Observable<ProcessDetail> {
        return this.http.put(`${this.apiController}/cancel/${processId}/${durationId}`, null)
            .pipe(distinctUntilChanged()) as Observable<ProcessDetail>;
    }

    clearSelectionClick() {
      this.clearSelectionSubject.next();
    }

}

